import type { FontStyles, TextStyles } from '../../types'
import { fontWeight } from './font-weight'
import { fonts } from './fonts'
import { getExtraTextStyles } from './utils'

export const fontStyles: FontStyles = {
  regular: {
    fontFamily: fonts.regular.family,
    fontWeight: fontWeight.regular,
  },
  medium: {
    fontFamily: fonts.medium.family,
    fontWeight: fontWeight.medium,
  },
  bold: {
    fontFamily: fonts.bold.family,
    fontWeight: fontWeight.bold,
  },
}

const { regular, medium, bold } = fontStyles

export const textStyles: TextStyles = {
  body: `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-body')}
  `,
  'body-intro': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-body')}
  `,
  blockquote: `
    font-family: ${bold.fontFamily};
    font-weight: ${bold.fontWeight};
    ${getExtraTextStyles('sb-text-blockquote')}
  `,
  quote: `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-quote')}
  `,
  label: `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-label')}
  `,
  overline: `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-overline')}
  `,
  standfirst: `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-standfirst')}
  `,
  'large-print-bold': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-large-print')}
  `,
  'small-print-regular': `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-small-print-regular')}
  `,
  'small-print-compact': `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-small-print-compact')}
  `,
  'small-print-medium': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-small-print-regular')}
  `,
  'small-print-bold': `
    font-family: ${bold.fontFamily};
    font-weight: ${bold.fontWeight};
    ${getExtraTextStyles('sb-text-small-print-regular')}
  `,
  'very-small-print': `
    font-family: ${regular.fontFamily};
    font-weight: ${regular.fontWeight};
    ${getExtraTextStyles('sb-text-very-small-print')}
  `,
  'very-small-print-bold': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-very-small-print')}
  `,
  'title-300': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-title-300')}
  `,
  'title-400': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-title-400')}
  `,
  'title-400-a': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-title-400')}
  `,
  'title-500': `
    font-family: ${medium.fontFamily};
    font-weight: ${medium.fontWeight};
    ${getExtraTextStyles('sb-text-title-500')}
  `,
  'title-600': `
    font-family: ${bold.fontFamily};
    font-weight: ${bold.fontWeight};
    ${getExtraTextStyles('sb-text-title-600')}
  `,
  'title-650': `
    font-family: ${bold.fontFamily};
    font-weight: ${bold.fontWeight};
    ${getExtraTextStyles('sb-text-title-650')}
  `,
  'title-700': `
    font-family: ${bold.fontFamily};
    font-weight: ${bold.fontWeight};
    ${getExtraTextStyles('sb-text-title-700')}
  `,
}
